
import React from 'react';

const InvestmentProcess: React.FC = () => {
  const steps = [
    {
      step: '01',
      title: 'Submit Application',
      description: 'Complete our comprehensive investment application form with your financial information and investment goals.',
      timeline: 'Day 1',
      icon: 'ri-file-text-line'
    },
    {
      step: '02',
      title: 'Initial Review',
      description: 'Our investment team reviews your application and conducts preliminary qualification assessment.',
      timeline: 'Days 2-3',
      icon: 'ri-search-line'
    },
    {
      step: '03',
      title: 'Consultation Call',
      description: 'Schedule a detailed consultation to discuss investment opportunities and answer your questions.',
      timeline: 'Week 1',
      icon: 'ri-phone-line'
    },
    {
      step: '04',
      title: 'Due Diligence',
      description: 'Review investment documents, financial projections, and property details with our team.',
      timeline: 'Weeks 2-3',
      icon: 'ri-file-chart-line'
    },
    {
      step: '05',
      title: 'Investment Agreement',
      description: 'Finalize investment terms and complete legal documentation with our legal partners.',
      timeline: 'Week 4',
      icon: 'ri-contract-line'
    },
    {
      step: '06',
      title: 'Fund Transfer',
      description: 'Transfer investment funds and receive confirmation of your ownership stake in the project.',
      timeline: 'Week 5',
      icon: 'ri-bank-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Investment Process
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We've streamlined our investment process to make it simple and transparent. 
            From application to funding, we guide you through every step.
          </p>
        </div>

        <div className="relative">
          {/* Timeline Line */}
          <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-emerald-200"></div>

          <div className="space-y-12">
            {steps.map((step, index) => (
              <div key={index} className={`flex flex-col lg:flex-row items-center ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}>
                {/* Content */}
                <div className={`w-full lg:w-5/12 ${index % 2 === 0 ? 'lg:pr-12' : 'lg:pl-12'}`}>
                  <div className="bg-white rounded-lg p-8 shadow-lg">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center justify-center w-12 h-12 bg-emerald-100 rounded-lg mr-4">
                        <i className={`${step.icon} text-xl text-emerald-600`}></i>
                      </div>
                      <div>
                        <div className="text-sm text-emerald-600 font-semibold">{step.timeline}</div>
                        <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                      </div>
                    </div>
                    <p className="text-gray-600">{step.description}</p>
                  </div>
                </div>

                {/* Step Number */}
                <div className="flex items-center justify-center w-16 h-16 bg-emerald-600 text-white rounded-full font-bold text-xl my-8 lg:my-0 relative z-10">
                  {step.step}
                </div>

                {/* Spacer */}
                <div className="w-full lg:w-5/12"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <div className="bg-white rounded-lg p-8 shadow-lg max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Get Started?</h3>
            <p className="text-gray-600 mb-6">
              Join our growing community of investors and start building your glamping portfolio today.
            </p>
            <a 
              href="#investment-application"
              className="inline-flex items-center bg-emerald-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Start Your Application
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentProcess;
